import { Form, Input, Grid, Select, Field, Button, Table, Icon, Dialog } from "@alifd/next";
import { BefGlobalContext, BefMessageServiceContext, BefRpcContext } from "@beflam/bef-core";

import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import SelectUsers from "./SelectUsers";
import { MixIcon } from "../MixIcon";

const AddUser = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, depId, ...otherProps } = props;
    const messageService = useContext(BefMessageServiceContext);
    const [dataSource, setDataSource] = useState<any>([]);
    const [formSource, setFormSource] = useState<any>({});
    const [ops, setOps] = useState<any>([]);
    const [userList, setUserList] = useState<any>([]);
    const befRpc = useContext(BefRpcContext);
    const sGlobal = useContext(BefGlobalContext);
    const tabRef = useRef<any>(null);
    let [visible, setVisible] = useState({ add: false });
    let depRef = useRef<any>(null);
    const setVisibleEx = (data: any) => {
        visible = data;
        setVisible(data);
    }
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setFormSource(data);
    }
    const fieldRef = useRef(new Field(contextComp));
    const Option = Select.Option;
    const render1 = (value: any, index: any, record: any) => {
        return <><Select
            className="custom-form-control"
            style={{ width: '100%' }}
            hasClear
            defaultValue={record.DepType}
            onChange={(value: any) => {
                selectChange(value, record);
            }}
        >
            {ops.map((op: any) => {
                return <Option key={op.Id} value={op.Id}>{op.Name}</Option>
            })}
        </Select></>
    }
    const getTypes = async () => {
        let typeRes = await befRpc.callRpcAsync<any[]>("", rpcAssembly, rpcModule, "TypeList", { AppId: sGlobal.currentAppId ,Id:depId});
        setOps(typeRes);
    }
    const getUserList = async () => {
        const wheres: any[] = [{ field: 'State', control: 'notEqualTo', value: "DL" }];
        let result = await befRpc.callRpcAsync<any[]>("", "Beflam.Framework", "Beflam.Framework.Service.UserService", "List", { Wheres: wheres });
        let data = result.map((item) => { return { value: item.UserId, label: item.UserName } });
        setUserList(data);
    }
    const selectChange = (value: any, record: any) => {
        if (value == undefined || value == null || value == "")
            record.DepType = '';
        else
            record.DepType = value; console.log(record);
    }
    useEffect(() => {
        if (depId) {
            getTypes();
        }
        getUserList();
        fieldRef.current.reset();
        fieldRef.current.setValues({ Ids: "" });
    }, []);
    useEffect(() => {

        tabRef.current = dataSource;
    }, [dataSource]);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = tabRef.current;
                console.log(result);
                return result;
            }
        });
        return proxy;
    }, []);
    const getValues = () => {
        const users = fieldRef.current.getValues() as any;
        if (users !== undefined && users !== null && users.Ids !== "") {
            let usersList = users?.Ids.split(',');
            let dts = [];
            for (let user of usersList) {
                if (dataSource.length == 0)
                    dts.push({ UserId: user, DepType: '' });
                else {
                    let _res = dataSource.find((it: any) => it.UserId == user);
                    if (_res == undefined || _res == null) {
                        dts.push({ UserId: user, DepType: '' });
                    }
                }
            }
            dts = [...dataSource, ...dts];
            setDataSource(dts);
            fieldRef.current.setValues({ Ids: "" });

        } else {
            messageService.showMessage(messageService.handleErr('请输入用户Id', "新增用户"));
        }

    }
    const userSelect = () => {
        setVisibleEx({ ...visible, add: true });
    }
    const onUserAdd = () => {
        fieldRef.current.setValues({ Ids: depRef.current.dataSource.selectedRowKeys.toString() });
        setVisibleEx({ ...visible, add: false });
    }
    const onDeleteUser = (val: any) => {
        let _data = dataSource.filter((item: any) => item.UserId != val.UserId);
        setDataSource(_data);
    }
    const userRender = (value: any, index: number, record: any) => {
        return <>

            <Button type="normal" size="large" title="删除用户" text style={{ color: '#ff383c' }} onClick={() => {

                //setDataSource({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                onDeleteUser(record);
            }}><MixIcon value="1:trash" size="small" style={{ marginRight: 0 }} /></Button>


        </>;
    };
    return (
        <>
            <div className="bef-custom-dep">
                <Form field={fieldRef.current}>
                    <Grid.Row gutter="12">
                        <Grid.Col>
                            <Form.Item label="用户Id（多个用户请用','分隔）" name="Ids" className="sdep-adduser custom-form-control"
                            >
                                <Input trim
                                    innerAfter={<Icon type="list" size="xs" onClick={userSelect} style={{ margin: 4 }} />}
                                />
                                <Button type="normal" size="medium" onClick={getValues} className="custom-btn height-42">新增</Button>
                            </Form.Item>
                        </Grid.Col>
                    </Grid.Row>

                </Form>
                <div style={{ height: "404px", overflow: "hidden" }}>
                    <div className="custom-table h-100">
                        <Table className=" height-100 bef-department-content  margin-bottom-8"
                            fixedHeader maxBodyHeight="348px" size='medium'
                            primaryKey="UserId" dataSource={dataSource}
                            hasBorder={false}
                            onResizeChange={(dataIndex: string, value: number) => {
                            }}
                        >
                            <Table.Column lock="right" title="操作" cell={userRender} width={77} />
                            <Table.Column title="用户" dataIndex="UserId" />
                            <Table.Column title="级别" cell={render1} dataIndex="DepType" />
                        </Table>
                    </div>

                </div>
            </div>
            <Dialog v2 title="选择用户" width={600} visible={visible.add} footerActions={['cancel', 'ok']} okProps={{ className: 'custom-dialog-btn-ok' }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, add: false })} onOk={onUserAdd}>
                <SelectUsers ref={depRef} selectedKeys={fieldRef.current.getValue('Ids')} />
            </Dialog>
        </>
    );
});
export default AddUser;